export const selectNotifications = state => state.error.notifications;